import React from 'react';
import ListBox, { IListBox } from '@monofront/design-system/components/ListBox';
import {
  useOurProspectGuaranteesContent,
  useOurServiceGuaranteesContent,
  useOurSubscriptionGuaranteesContent,
} from './presets';
import { OurGuaranteesKeys, ourGuaranteesPresets } from './types';
import { useTranslations } from 'next-intl';

const useGetPresetContent = (
  preset: ourGuaranteesPresets,
  isShoppingCartFUF = false,
): IListBox<OurGuaranteesKeys> => {
  let content: IListBox<OurGuaranteesKeys>;
  const ourProspectGuaranteesContent = useOurProspectGuaranteesContent({
    isShoppingCartFUF,
  });
  const ourServiceGuaranteesContent = useOurServiceGuaranteesContent();
  const ourSubscriptionGuaranteesContent =
    useOurSubscriptionGuaranteesContent();

  switch (preset) {
    case ourGuaranteesPresets.SUBSCRIPTION:
      content = ourSubscriptionGuaranteesContent;
      break;
    case ourGuaranteesPresets.SERVICE:
      content = ourServiceGuaranteesContent;
      break;
    case ourGuaranteesPresets.PROSPECT:
      content = ourProspectGuaranteesContent;
      break;
    default:
      content = ourServiceGuaranteesContent;
  }

  return content;
};

const useTranslateContent = ({ lines, title }: IListBox<OurGuaranteesKeys>) => {
  const tOurGuarantees = useTranslations('OurGuarantees');

  return {
    // @TODO fix tOurGuarantees typings
    title: tOurGuarantees(title as any),
    lines: lines.map(({ icon, text, variables }) => ({
      icon,
      text: variables
        ? tOurGuarantees.rich(text, { ...variables })
        : tOurGuarantees(text),
    })),
  };
};

const CustomOurGuarantees: React.FC<{
  preset: ourGuaranteesPresets;
  isShoppingCartFUF?: boolean;
}> = ({ preset, isShoppingCartFUF = false }) => {
  const presetContent = useGetPresetContent(preset, isShoppingCartFUF);
  const translatedContent = useTranslateContent(presetContent);

  return <ListBox content={translatedContent} />;
};

export default CustomOurGuarantees;
